import { createSlice } from "@reduxjs/toolkit";
import { Routes } from "../../../routes/routes";

export interface HeaderMenuState {
    selectedMenu: Routes;
}

const initialState: HeaderMenuState = {
    selectedMenu: Routes.HOME
};

export const headerMenuSlice = createSlice({
  name: "headerMenu",
  initialState,
  reducers: {
    update: (state, action) => {
      const { selectedMenu } = action.payload;
      state.selectedMenu = selectedMenu;
    },
  },
});

export const { update } = headerMenuSlice.actions;
export default headerMenuSlice.reducer;
